import {isEmpty} from 'lodash'
import {getDateRangeForKeyAndDate} from 'helpers/dateRange'

export const getDiaryParams = (activityFilters, invoiceFinancialYearStart, expandRange) => {
  const {
    selectedDate,
    diaryRange,
    users,
    companies,
    contacts,
    references,
    activityStatuses,
    activityTypes,
  } = activityFilters

  const dateRangeForKey = getDateRangeForKeyAndDate(diaryRange, selectedDate, invoiceFinancialYearStart, false, expandRange)
  const {startDate, endDate} = dateRangeForKey

  const params = {
    contactId: !isEmpty(contacts)
        ? contacts.map((contact) => {
          return contact.value
        })
        : [],
    attendees: !isEmpty(users)
        ? users.filter(user => user.team === false).map((user) => {
          return user.value
        })
        : [],
    attendeeTeams: !isEmpty(users)
        ? users.filter(user => user.team === true).map((user) => {
          return user.value
        })
        : [],
    companyId: !isEmpty(companies)
        ? companies.map((company) => {
          return company.value
        })
        : [],
    opportunityId: !isEmpty(references)
        ? references.filter(ref => ref.type === 'opportunity').map(reference => reference.id)
        : [],
    orderId: !isEmpty(references)
        ? references.filter(ref => ref.type === 'order').map(reference => reference.id)
        : [],
    includeScheduled: true,
    includeUnscheduled: true,
    rangeStart: startDate,
    rangeEnd: endDate,
    showHiddenTypes: false,
    types: !isEmpty(activityTypes)
        ? activityTypes
        : [],
  }

  if (!isEmpty((activityStatuses)))
    params.statuses = activityStatuses

  return params
}
